import Cookies from 'js-cookie';
import { getBaseUrl } from './baseUrl';
import { parseJSON } from './utils';

const baseUrl = getBaseUrl();
let isUnauthorizedRedirecting = false;

const clearAuthState = () => {
  Cookies.remove('authu', { path: '/' });
  localStorage.removeItem('authToken');
  localStorage.removeItem('authu');
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('authu');
};

// Helper function to handle 401 Unauthorized responses globally
export const handleUnauthorized = () => {
  clearAuthState();

  if (!isUnauthorizedRedirecting && window.location.pathname !== '/') {
    isUnauthorizedRedirecting = true;
    window.location.assign('/');
  }
};

const request = async (/** @type {string} */ url: string, options: any = {}, isFile: boolean = false) => {
  // Get fresh authu cookie on each request
  const authu = Cookies.get('authu');
  
  // Set the headers conditionally based on the content type
  const headers: any = {
    ...options.headers, // Allow overriding or adding custom headers
  };

  // Only add Authorization header if authu cookie exists and it's not a login/logout endpoint
  if (authu && !url.includes('/user/login') && !url.includes('/user/logout')) {
    headers['Authorization'] = 'Bearer ' + authu;
  }

  let body: any = undefined;

  // Only set body for non-GET requests
  if (options.method !== 'GET' && options.method !== 'HEAD') {
    if (isFile) {
      // If handling file uploads, expect options.body to be FormData
      body = options.body;
    } else {
      headers['Content-Type'] = 'application/json; charset=UTF-8';
      body = options.body || {};
    }
  }

  const config: any = {
    credentials: 'include',
    ...options,
    headers,
  };

  // Only add body to config if it's defined
  if (body !== undefined) {
    config.body = body;
  }

  const response = await fetch(`${baseUrl}${url}`, config);

  // Handle 401 Unauthorized - remove cookie and redirect to login
  if (response.status === 401) {
    handleUnauthorized();
    const unauthorizedError: any = new Error('Unauthorized: Session expired. Please login again.');
    unauthorizedError.status = 401;
    throw unauthorizedError;
  }

  if (!response.ok) {
    const httpError: any = new Error(`HTTP error! Status: ${response.status}`);
    httpError.status = response.status;
    throw httpError;
  }

  return isFile ? response : parseJSON(response);
};

export default request;
